/**
 * Import Dependency
 */
import Vue from 'vue'
import Vuex from 'vuex'

/**
 * Root Scope of VUEX
 */
import * as getters from './getters'
import { state, actions, mutations } from './root'

/**
 * Module Scope of VUEX
 */
import page from './modules/page'
import auth from './modules/auth'
import user from './modules/user'
import pnotify from './modules/pnotify'

import dashboard from './modules/app/dashboard'
import users from './modules/app/users'

/**
 * Config
 */
Vue.use(Vuex)

/**
 * Export
 */
export default new Vuex.Store({
	state,
	actions,
	mutations,
	getters,
	modules: {
		page,
		auth,
		user,
		pnotify,

		dashboard,
		users
	},
	strict: true
})